import { BankOutlined, PoweroffOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Dropdown, MenuProps } from 'antd';
import TcButton from 'components/UI/button/TcButton';
import HeaderNotification from 'components/UI/layout/components/headerNotification/HeaderNotification';
import routes from 'global/Constants/routes';
import { FC, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { getUserPersonFullInfo } from 'redux/reducer/user/getUserPersonFullInfo';
import { userHandleLogout } from 'redux/reducer/user/userReducer';
import { RootState, store } from 'redux/store';

const HeaderUser: FC = () => {
  //states
  const { userProfile, userAllowed, userPerson } = useSelector((state: RootState) => state.user);

  //hooks
  const { push } = useHistory();

  //effect
  useEffect(() => {
    !userPerson && userProfile && userProfile?.personId && store.dispatch(getUserPersonFullInfo(userProfile?.personId));
  }, [userPerson, userProfile]);

  //constant
  const items: MenuProps['items'] = [
    ...(userAllowed.hasCustomer
      ? [
          {
            label: 'حساب کاربری',
            key: '1',
            icon: <UserOutlined />,
            onClick: () => push(routes.profile.path),
          },
          // {
          //   label: 'کسب و کار',
          //   key: '2',
          //   icon: <MdOutlineWorkOutline />,
          //   onClick: () => push(routes.personBusinessProfile.path),
          // },
          {
            label: 'حساب های بانکی',
            key: '3',
            icon: <BankOutlined />,
            onClick: () => push(routes.personBankAccount.path),
          },
        ]
      : []),
    // {
    //   label: 'تنظیمات',
    //   key: '4',
    //   icon: <AiOutlineSetting />,
    //   onClick: () => push(routes.setting.path),
    // },
    {
      label: 'خروج از حساب',
      key: '5',
      icon: <PoweroffOutlined />,
      danger: true,
      onClick: () => store.dispatch(userHandleLogout()),
    },
  ];
  const menuProps = {
    items,
  };
  const renderUserFullname = useMemo(() => {
    if (userPerson?.fullName) return userPerson.fullName;
    if (userProfile?.email) return userProfile.email;
    return <></>;
  }, [userProfile, userPerson]);

  if (!userProfile)
    return (
      <Link to={routes.login.path}>
        <TcButton type='default' className='flex items-center'>
          <UserOutlined />
          ورود به حساب
        </TcButton>
      </Link>
    );
  return (
    <>
      <HeaderNotification />

      <Dropdown menu={menuProps} placement='bottom'>
        <Button type='default' className='flex items-center'>
          <UserOutlined />
          <span className='hidden sm:inline-block'>{renderUserFullname}</span>
        </Button>
      </Dropdown>
      {/* Notification */}
    </>
  );
};

export default HeaderUser;
